module.exports = __webpack_public_path__ + "src/assets/images/icon-pipeline-summary-leads.png?48804b2603cd829082e10dbe2d97ca06";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-pipeline-summary-leads.png
// module id = 1007
// module chunks = 1